import React, { useRef } from "react";
import { useEffect } from "react";
import { CUMap } from "../../classes/CUMap.class";
import { isMapboxURL, transformMapboxUrl, } from "maplibregl-mapbox-request-transformer";
import { AttributionControl } from "maplibre-gl";
export default function Map(props) {
    const initMount = useRef(true);
    const mapContainer = useRef(null);
    // it's really important to use a ref for the map instead of a exported global object! Otherwise it may
    // cause bugs with a routing system due to mount and unmount
    const transformRequest = (url, resourceType) => {
        var _a, _b;
        if (url == null)
            return { url: "" };
        const accessToken = (_b = (_a = props.cuMapRef.current) === null || _a === void 0 ? void 0 : _a.piData) === null || _b === void 0 ? void 0 : _b.produktinstanz.mapboxAccessToken;
        if (accessToken == null)
            return {
                url: url,
            };
        if (isMapboxURL(url)) {
            if (resourceType === undefined)
                return { url: "" };
            return transformMapboxUrl(url, resourceType, accessToken);
        }
        return { url };
    };
    const loadCall = () => {
        var _a;
        props.setMapLoaded(true);
        if (props.onLoad && ((_a = props.cuMapRef) === null || _a === void 0 ? void 0 : _a.current)) {
            props.onLoad(props.cuMapRef.current);
        }
    };
    const setInteriorLoaded = () => {
        if (props.onMapInteriorLoaded)
            props.onMapInteriorLoaded(true);
    };
    const setPiDataLoaded = () => {
        props.setPiDataLoaded(true);
    };
    const setMarkerZoomHandler = (cuMap) => {
        cuMap.off("zoom", (event) => {
            cuMap.markerZoomHandler(event.target.getZoom());
        });
        cuMap.on("zoom", (event) => {
            cuMap.markerZoomHandler(event.target.getZoom());
        });
    };
    const initMap = () => {
        if (props.cuMapRef.current || !mapContainer.current)
            return; // initialize map only once
        const cuMap = new CUMap(props.cuData, {
            ...props.mapboxOptions,
            attributionControl: false,
            // customAttribution: "© Catchup Applications ",
            container: mapContainer.current,
            transformRequest,
        }, props.setBadOsmIds, props.setLevelState, props.regExRoomLabel);
        const customAttributionControl = new AttributionControl({
            customAttribution: "© Catchup Applications",
            compact: true,
        });
        cuMap.addControl(customAttributionControl);
        cuMap.subscribe("layersSourcesInitialized", "intern_layersInitialized", loadCall);
        cuMap.subscribe("geoJSONLoaded", "intern_geojsonloaded", setInteriorLoaded);
        setTimeout(() => {
            // some legacy clients don't have geojson interiors, so there must be a safetynet
            setInteriorLoaded();
        }, 2000);
        cuMap.subscribe("piDataLoaded", "intern_piloaded", setPiDataLoaded);
        props.cuMapRef.current = cuMap;
        // @ts-ignore
        window.cuMap = cuMap;
        initMount.current = false;
        setMarkerZoomHandler(cuMap);
        // cuMap.subscribe("geoJSONLoaded", "intern_geojsonloaded2", (cuMap) => {
        //   setMarkerZoomHandler(cuMap);
        // });
    };
    useEffect(initMap, []);
    return (React.createElement("div", { ref: mapContainer, style: {
            height: "100%",
            width: "100%",
            pointerEvents: props.mapLoaded ? "all" : "none",
        } }));
}
